/**
 * 인증 처리 API
 */
import { api, apiNa } from "@/redworks/api/index";

const AUTH_PATH = {
  LOGIN: "/v1/auth/login", // 로그인 API
  USEPLC_LOGIN: "/v1/auth/usePlcLogin", // 로그인 API
  LOGOUT: "/v1/auth/logout", // 로그아웃 API
  REISSUE: "/v1/auth/reissue", // 토큰 재발행 API
  CHECK_AUTH: "/v1/auth/checkAuthorization", // 인증 check
  CHECK_USEPLC_AUTH: "/v1/auth/checkUseplcAuthorization", // 인증 check
  DUPLICATED_LOGIN: "/v1/auth/duplicatedLogin", // 인증 check
  USEPLC_REISSUE: "/v1/auth/useplcReissue", // 인증 check
};

const AUTH_RST_CD = {
  SUCCESS: 200,
  UNAUTHORIZED: 401, // 미인증 / 인증기간 만료
  NON_PERMISSION: 403, // API 권한 없음
  NOT_FOUND: 404,
};

// 로그인 API
function $login(loginForm) {
  return apiNa.post(AUTH_PATH.LOGIN, loginForm);
}
function $usePlcLogin(loginForm) {
  return apiNa.post(AUTH_PATH.USEPLC_LOGIN, loginForm);
}

// 중복 로그인 체크 API
function $checkDuplicateLogin(loginForm) {
  return apiNa.post(AUTH_PATH.DUPLICATED_LOGIN, loginForm);
}

// 로그아웃 API
function $logout(refreshToken) {
  return api.post(AUTH_PATH.LOGOUT, refreshToken);
}

// 인증 체크 API
function $checkAuth() {
  return api.get(AUTH_PATH.CHECK_AUTH);
}
// 인증 체크 API
function $checkUsePlcAuth(mode) {
  return api.get(AUTH_PATH.CHECK_USEPLC_AUTH, mode);
}

export {
  AUTH_PATH,
  AUTH_RST_CD,
  $login,
  $logout,
  $checkAuth,
  $checkDuplicateLogin,
  $usePlcLogin,
  $checkUsePlcAuth
};
